<template>
  <div></div>
</template>
 
<script>
import axios from "axios";
import { mapMutations } from "vuex";
import { loginController } from "@/api/activityController";
export default {
  name: "refresh",
  data() {
    return {};
  },
  methods: {
    ...mapMutations({
      editPointUserInfo: "POINTUSERINFO",
    }),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // console.log('router beforeRouteEnter')
      // vm.$router.replace(from.path)
      var token = vm.$route.query.token;
      var isIntegral = vm.$route.query.isIntegral;
      var venderId = vm.$route.query.venderId;
      // console.log('token', token)
      console.log("toke:", token);
      axios.get("/jd-yusms/login/login-from-old?token=" + token).then((res) => {
        console.log(res);
        console.log("重定向跳转关闭_v1.1");
        if (isIntegral) {
          loginController({
            venderId,
          }).then((resX) => {
            console.log('resX', resX)
            if (resX && resX.code == 1) {
              if (
                resX.data.appInfo.status == 1 &&
                resX.data.orderInfo.status == 1
              ) {
                console.log("登录成功");
                vm.editPointUserInfo(resX.data.orderInfo);
                vm.$router.push("/integralCenter");
              } else if (resX.data.orderInfo.status != 1) {
                let routeUrl = vm.$router.resolve({
                  path: "/prizeCenter2",
                });
                window.open(routeUrl.href, "_blank");
                window.open("/home", "_self");
              } else {
                window.open(resX.data.appInfo.authUrl, "_blank");
                window.open("/home", "_self");
              }
            } else {
              if (resX.data.data.orderInfo.status != 1) {
                let routeUrl = vm.$router.resolve({
                  path: "/prizeCenter2",
                });
                window.open(routeUrl.href, "_blank");
              } else {
                window.open(resX.data.data.appInfo.authUrl, "_blank");
              }
              window.open("/home", "_self");
            }
          });
        } else {
          vm.$router.push("/home");
        }
      });
    });
  },
};
</script>
<style scoped>
</style>